import cover1 from '../assets/project-1.jpg'
import cover2 from '../assets/project-2.jpg'
import cover3 from '../assets/project-3.jpg'
import cover4 from '../assets/project-4.jpg'
import cover5 from '../assets/project-5.jpg'
import cover6 from '../assets/project-6.jpg'
import cover7 from '../assets/Frame 7.png'



export const SelectedPage = {
    Home: 'home',
    Skills: 'skills',
    Projects: 'projects',
    Contact: 'contact'
};

export const images = [cover1, cover2, cover3,cover1, cover2, cover3,cover1, cover2, cover3];


export const works = [
    {
      imgSrc: cover1,
      title: 'Full stack music app',
      tags: ['API', 'MVC', 'Development'],
      projectLink: 'https://musify-5al0.onrender.com/'
    },
    {
      imgSrc: cover2,
      title: 'Free stock photo app',
      tags: ['API', 'SPA'],
      projectLink: 'https://pixstock-official.vercel.app/'
    },
    {
      imgSrc: cover3,
      title: 'Recipe app',
      tags: ['Development', 'API'],
      projectLink: ''
    },
    {
      imgSrc: cover4,
      title: 'Real state website',
      tags: ['Web-design', 'Development'],
      projectLink: 'https://github.com/codewithsadee-org/wealthome'
    },
    {
      imgSrc: cover5,
      title: 'eCommerce website',
      tags: ['eCommerce', 'Development'],
      projectLink: 'https://github.com/codewithsadee/anon-ecommerce-website'
    },
    {
      imgSrc: cover6,
      title: 'vCard Personal portfolio',
      tags: ['Web-design', 'Development'],
      projectLink: 'https://github.com/codewithsadee/vcard-personal-portfolio'
    },
    {
      imgSrc: cover7,
      title: 'Free Personal portfolio',
      tags: ['Web-design', 'Development'],
      projectLink: 'https://github.com/codewithsadee/vcard-personal-portfolio'
    },
  ];



